import CommonError from '@/common/utils/errors/CommonError';

export default class TaskError extends CommonError {
  task: TaskObject;
  constructor(task: TaskObject) {
    super();
    this.name = 'Task error';

    this.task = task;

    this.message = task.error || 'Task failed due to unknown reason';
  }
}
